var _style, _g, _g2, _circle, _circle2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentiApprovedClinicBadgeEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 338.52 336.07",
    style: {
      enableBackground: "new 0 0 338.52 336.07"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#339CA6;}\n\t.st1{fill:none;stroke:#339CA6;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.15,71.76l-12.18,7.68l2.16,10.93l-3.3,2.08l-6.53-35.3l3.04-1.92l28.99,21.15l-3.26,2.05L117.15,71.76z  M114.17,69.57l-13.08-9.78l3.18,16.02L114.17,69.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.69,74.78l-3.47,0.97l-8.99-32.12l11.41-3.19c3.59-1.01,6.58-0.93,8.97,0.24 c2.39,1.17,4.03,3.35,4.93,6.56c0.9,3.21,0.63,5.93-0.8,8.17c-1.43,2.24-3.95,3.86-7.54,4.86l-7.94,2.22L135.69,74.78z  M138.83,57.08c3.21-0.9,5.19-2.11,5.94-3.64c0.75-1.53,0.85-3.27,0.3-5.22c-0.55-1.96-1.54-3.39-2.97-4.31 c-1.43-0.91-3.75-0.92-6.96-0.02l-7.51,2.1l3.69,13.19L138.83,57.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.4,68.99l-3.6-0.04l0.4-33.35l11.85,0.14c3.73,0.04,6.58,0.96,8.54,2.75c1.96,1.79,2.92,4.35,2.88,7.69 s-1.06,5.87-3.07,7.61c-2,1.74-4.87,2.59-8.61,2.55l-8.25-0.1L163.4,68.99z M171.4,52.88c3.33,0.04,5.57-0.57,6.72-1.82 c1.15-1.25,1.73-2.9,1.76-4.93c0.02-2.03-0.52-3.69-1.64-4.97c-1.12-1.28-3.34-1.94-6.68-1.98l-7.8-0.09l-0.16,13.7L171.4,52.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.96,76.3l-4.31-15.43l-8.12-2.52l-3.99,12.84l-3.44-1.07l9.9-31.85l13.08,4.07 c3.09,0.96,5.18,2.47,6.29,4.52c1.11,2.05,1.18,4.61,0.23,7.67c-0.76,2.45-2.06,4.32-3.89,5.6c-1.83,1.28-3.91,1.79-6.23,1.52 l4.53,15.91L207.96,76.3z M196.54,55.1l8.07,2.51c2.61,0.81,4.68,0.88,6.22,0.21c1.54-0.67,2.63-2.04,3.27-4.11 c0.63-2.04,0.64-3.74,0.02-5.1c-0.62-1.36-2.1-2.41-4.42-3.13l-9.26-2.88L196.54,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.92,77.09c-0.44-3.8,0.94-8.04,4.15-12.71c3.21-4.67,6.66-7.48,10.37-8.44c3.71-0.95,7.59-0.03,11.66,2.76 c4.09,2.81,6.36,6.12,6.81,9.92c0.44,3.8-0.94,8.04-4.15,12.71c-3.21,4.67-6.67,7.48-10.37,8.44c-3.71,0.95-7.61,0.02-11.7-2.79 C221.61,84.19,219.36,80.89,218.92,77.09z M236.56,86.32c2.73-0.79,5.44-3.16,8.14-7.09c2.68-3.9,3.9-7.28,3.67-10.12 c-0.23-2.85-1.97-5.38-5.21-7.61c-3.22-2.21-6.19-2.91-8.93-2.1c-2.74,0.81-5.45,3.16-8.13,7.07c-2.7,3.93-3.93,7.31-3.69,10.14 c0.24,2.83,1.96,5.35,5.18,7.56C230.85,86.4,233.83,87.12,236.56,86.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.19,98.1l-34.15,10.5l-2.19-2.79l18.36-30.65l2.38,3.03L251.8,104.4l29.03-9.16L283.19,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.86,109.12l7.89,19.52l-3.15,1.28l-6.54-16.18l-10.66,4.31l5.75,14.23l-3.25,1.31l-5.75-14.23l-10.71,4.33 l6.54,16.18l-3.15,1.27l-7.89-19.52L288.86,109.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.63,143.42l1.01,10.4c0.5,5.18-0.51,9.2-3.02,12.07c-2.52,2.87-6.53,4.58-12.04,5.11 c-11.08,1.08-17.13-3.58-18.13-13.96l-1.01-10.4L300.63,143.42z M271.81,156.46c0.41,4.21,1.77,7.19,4.08,8.92 c2.31,1.74,5.76,2.38,10.34,1.94c4.58-0.44,7.83-1.74,9.77-3.89c1.93-2.15,2.7-5.33,2.29-9.54l-0.64-6.57l-26.48,2.57 L271.81,156.46z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.26,254.91c0.23-3.85,2.37-7.76,6.4-11.74c4.04-3.98,7.98-6.05,11.84-6.22c3.85-0.17,7.58,1.57,11.18,5.23 c2.38,2.42,4.18,5.41,5.37,8.95l-2.46,2.42c-1.01-3.4-2.7-6.3-5.06-8.7c-2.95-2.99-5.88-4.41-8.81-4.24 c-2.92,0.17-6.07,1.91-9.45,5.23c-3.4,3.34-5.2,6.46-5.41,9.36c-0.21,2.9,1.17,5.85,4.14,8.87c2.48,2.52,5.34,4.26,8.59,5.23 l-2.46,2.42c-3.53-1.3-6.47-3.15-8.83-5.55C70.72,262.52,69.03,258.76,69.26,254.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.04,251.91l3.08,1.86l-15.41,25.56l14.6,8.8l-1.81,3l-17.69-10.66L109.04,251.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.28,263.38l3.35,1.31l-12.18,31.04l-3.35-1.32L130.28,263.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.12,271.87l-5.17,32.95l-4-0.63l-15.36-30.85l-4.35,27.76l-3.56-0.56l5.17-32.95l4.05,0.64l15.31,30.84 l4.35-27.76L166.12,271.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.52,271.16l3.6-0.16l1.49,33.32l-3.6,0.16L172.52,271.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.62,299.11c-3.18-2.19-5.43-6.03-6.75-11.55c-1.32-5.51-1.06-9.96,0.79-13.35 c1.85-3.39,5.26-5.68,10.26-6.88c3.31-0.79,6.79-0.79,10.44,0.02l0.8,3.36c-3.44-0.89-6.79-0.94-10.06-0.16 c-4.08,0.98-6.81,2.76-8.18,5.35c-1.37,2.59-1.5,6.19-0.4,10.79c1.11,4.64,2.85,7.79,5.22,9.47c2.37,1.68,5.62,2.02,9.73,1.04 c3.43-0.82,6.41-2.37,8.91-4.65l0.8,3.35c-2.93,2.35-6.04,3.91-9.31,4.7C198.89,301.79,194.8,301.29,191.62,299.11z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 169.66,
    cy: 168.51,
    r: 151.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 169.55,
    cy: 168.71,
    r: 84.47
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.74,222.95h-0.01c-1.12,0-2.19-0.61-2.98-1.66l-33.12-44.51c-1.64-2.21-1.63-5.77,0.02-7.96 c1.67-2.2,4.32-2.18,5.96,0.02l30.13,40.51l60.45-80.66c1.65-2.2,4.32-2.2,5.96,0c1.65,2.19,1.65,5.76,0,7.96l-63.43,84.65 C155.93,222.36,154.86,222.95,153.74,222.95z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentiApprovedClinicBadgeEn);
export default __webpack_public_path__ + "static/media/denti-approved-clinic-badge_en.9f667c065724362a2b62f6ef15e1e2e3.svg";
export { ForwardRef as ReactComponent };